import React, { Component } from 'react';
import Calculator from './components/Calculator/Calculator';
import './App.css';

class App extends Component {
  render() {
    return <Calculator />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx